import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Footer from '../../CoreComponents/Footer'
import Header from '../../CoreComponents/Header'
import MainHeader from '../../CoreComponents/MainHeader'
import NavBar from '../../CoreComponents/NavBar'
import { showMessage } from '../../Functionalities/Functions'
import { ManageProfile } from './Logic'

function Body(props) {
    let id = props.id
    const [errors, setErrors] = useState([])
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        email: "",
        mobile: "",
        username: "",
        address1: "",
        latitude: "",
        longitude: "",
        password: "",
        confirm_password: "",
        is_approved: "",
        is_blocked: "",
        keyword: "shop"
    })
    useEffect(() => {
        fetchData()
        if (errors.length > 0) {
            showMessage(errors[0], "danger", " Following fields are required!", "top", "top-right", 0)
        }
    }, [errors])
    const fetchData = () => {
        let result = ManageProfile('', '', 'get', `keyword=all_profile&user_id=${id}`)
        result.then((result) => {
            setFormData({
                ...formData,
                id: result.data.results[0].id,
                name: result.data.results[0].first_name,
                email: result.data.results[0].email,
                mobile: result.data.results[0].details ? result.data.results[0].details.mobile : 0,
                username: result.data.results[0].username,
                address1: result.data.results[0].address.length > 0 ? result.data.results[0].address[0].address1 : "",
                latitude: result.data.results[0].address.length > 0 ? result.data.results[0].address[0].latitude : "",
                longitude: result.data.results[0].address.length > 0 ? result.data.results[0].address[0].longitude : "",
                is_approved: result.data.results[0].details ? result.data.results[0].details.is_approved : true,
                is_blocked: result.data.results[0].details ? result.data.results[0].details.is_blocked : false
            })
        })
    }
    return (
        <div className="content-body">
            <div className="container-fluid">
                <div className="card-header">
                    <div className="d-sm-flex mb-lg-4 mb-2">
                        <div className="mt-4" className="text-left">
                            <a href onClick={() => window.history.back()} className="btn btn-primary mb-1 mr-1"> Back </a>
                        </div>
                    </div>

                </div>

                <div className="card-body">
                    <div className="basic-form">
                        <form>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">First name<span class="required">*</span> :{" "}</label>
                                <div className="col-sm-9">
                                    <input type="text" className="form-control" value={formData.name} onChange={(e) => { setFormData({ ...formData, name: e.target.value }) }}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Username<span class="required">*</span> :</label>
                                <div className="col-sm-9">
                                    <input type="text" className="form-control" value={formData.username} onChange={(e) => { setFormData({ ...formData, username: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Password
                                  :</label>
                                <div className="col-sm-9">
                                    <input type="password" className="form-control" value={formData.password} onChange={(e) => { setFormData({ ...formData, password: e.target.value }) }} />
                                </div>
                            </div>
                            {formData.password && <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                    Confirm Password
                                    {formData.password !== "" && <span class="required">*</span>}
                                    :
                                </label>
                                <div className="col-sm-9">
                                    <input type="password" className="form-control" value={formData.confirm_password} onChange={(e) => { setFormData({ ...formData, confirm_password: e.target.value }) }} />
                                </div>
                            </div>}
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Email<span class="required">*</span>:{" "}</label>
                                <div className="col-sm-9">
                                    <input type="email" className="form-control" value={formData.email} onChange={(e) => { setFormData({ ...formData, email: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Mobile<span class="required">*</span> :{" "}</label>
                                <div className="col-sm-9">
                                    <input type="number" onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                        onWheelCapture={e => {
                                            e.target.blur()
                                        }} className="form-control" value={formData.mobile} onChange={(e) => { setFormData({ ...formData, mobile: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Address  :{" "}</label>
                                <div className="col-sm-9">
                                    <input type="text" className="form-control" value={formData.address1} onChange={(e) => { setFormData({ ...formData, address1: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Latitude  :{" "}</label>
                                <div className="col-sm-9">
                                    <input type="number" onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                        onWheelCapture={e => {
                                            e.target.blur()
                                        }} className="form-control" value={formData.latitude} onChange={(e) => { setFormData({ ...formData, latitude: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Longitude  :{" "}</label>
                                <div className="col-sm-9">
                                    <input type="number" onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                        onWheelCapture={e => {
                                            e.target.blur()
                                        }} className="form-control" value={formData.longitude} onChange={(e) => { setFormData({ ...formData, longitude: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="form-group row text-right">
                                <div className="col-sm-12">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={
                                            (e) => {
                                                e.preventDefault()

                                                setErrors([])
                                                if (formData.name === "") {
                                                    setErrors(["first_name"])
                                                    return
                                                }
                                                if (formData.username === "") {
                                                    setErrors(["username"])
                                                    return
                                                }
                                                // if (formData.password === "") {
                                                //     setErrors(["password"])
                                                //     return
                                                // }
                                                if (formData.password !== formData.confirm_password) {
                                                    setErrors(["Passwords not match"])
                                                    return
                                                }
                                                if (formData.email === "") {
                                                    setErrors(["email"])
                                                    return
                                                }
                                                if (formData.mobile === "") {
                                                    setErrors(["mobile"])
                                                    return
                                                }
                                                // if (formData.address1 === "") {
                                                //     setErrors(["address"])
                                                //     return
                                                // }
                                                // if (formData.latitude === "") {
                                                //     setErrors(["latitude"])
                                                //     return
                                                // }
                                                // if (formData.longitude === "") {
                                                //     setErrors(["longitude"])
                                                //     return
                                                // }
                                                let result = ManageProfile(e, formData, "update", "")
                                                result.then(result => {
                                                    if (result.data.Status === true) {
                                                        showMessage("Profile details updated successfully", "success", "Success!", "top", "top-right", 0)
                                                    }
                                                    else {

                                                        showMessage(result.data.Error, "danger", "Failed!", "top", "top-right", 0)
                                                    }
                                                })
                                            }
                                        }
                                    > Save
                        </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>



            </div>
        </div>

    )

}

function PasswordResetForShop() {
    const header = "Reset Password";
    let { id } = useParams();
    return (
        <div>
            <div id="main-wrapper">
                <MainHeader />
                <Header name={header} />
                <NavBar />
                <Body id={id} />
                <Footer />
            </div>
        </div>
    );
}

export default PasswordResetForShop
